import { call, put, takeEvery } from 'redux-saga/effects';
import { getIdToken, getErrorData } from '../../utils/helperFunctions';
import { getUserActListRequest } from '../../utils/httpRequests';
import {
  GET_USER_ACT_LIST_REQUESTED,
  GET_USER_ACT_LIST_FAILED,
  GET_USER_ACT_LIST_SUCCESS,
} from '../actions/actionTypes';

// sagas
export function* getUserActListSaga({ payload: { userActSearchCriteria } }) {
  try {
    const idToken = yield getIdToken();
    const data = yield call(
      getUserActListRequest,
      userActSearchCriteria,
      idToken,
    );
    yield put({
      type: GET_USER_ACT_LIST_SUCCESS,
      payload: { data },
    });
  } catch (err) {
    yield put({
      type: GET_USER_ACT_LIST_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

// watchers
export function* getUserActListWatcher() {
  yield takeEvery(GET_USER_ACT_LIST_REQUESTED, getUserActListSaga);
}
